import { render } from "./ListingSettingsColumnItem.vue?vue&type=template&id=2b20a15c&scoped=true"
import script from "./ListingSettingsColumnItem.vue?vue&type=script&lang=js"
export * from "./ListingSettingsColumnItem.vue?vue&type=script&lang=js"

import "./ListingSettingsColumnItem.vue?vue&type=style&index=0&id=2b20a15c&lang=scss&scoped=true"

import exportComponent from "../../../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2b20a15c"]])

export default __exports__